import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../../styles/Test.css";
import { getRandomQuestions, postVerifyStudent, postSubmitScore } from "../../services/getTestApi";

const TestComponent = () => {
  const [isVerified, setIsVerified] = useState(false);
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [progress, setProgress] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [studentId, setStudentId] = useState(null); 

  const handleVerifyStudent = async () => {
    try {
      await postVerifyStudent({ email, mobile }).then((res)=>{
        console.log("Response: ",res)
        if(res.status === 200){
          if(res.data.student.verify === 1){
            setIsVerified(true);
            setStudentId(res.data.student.id); 
            Swal.fire({
              icon: "success",
              title:"Details verified!",
              showConfirmButton: false,
              timer: 1000
            });
          }  
          else if(res.data.student.verify != 1){
            Swal.fire({
              icon: "error",
              title: `Your Payment status is not verified yet!`,
              showConfirmButton: true,
            
            });

          }
        }
        else{
        
          Swal.fire({
            icon: "error",
            title: `${res.response.data.message}!`,
            showConfirmButton: true,
            // timer: 1000
          });
        }
      })
     
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred. Please try again.";
      await Swal.fire({
                icon: "error",
                title: `${error.response?.data?.message}!`,
                showConfirmButton: false,
                timer: 1000
              });
    }
  };

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const response = await getRandomQuestions();
        setQuestions(response.data);
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    };

    fetchQuestions();
  }, []);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const handleContinue = () => {
    if (selectedOption?.is_correct) {
      setScore(score + 1); 
    }

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setProgress(((currentQuestion + 1) / questions.length) * 100);
      setSelectedOption(null);
    } else {
      handleSubmitScore(); 
    }
  };

  const handleSubmitScore = async () => {
    try {
      const response = await postSubmitScore({ student_id: studentId, score }).then((res)=>{
        console.log("res",res)
        if(res.status === 200){
          Swal.fire("Success", res.data.message, "success");
          window.location.reload();

        }
      })
      
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "An error occurred. Please try again.";
      Swal.fire({
               icon: "error",
               title: `${error.response.data.message}!`,
               showConfirmButton: false,
               timer: 1000
             });
    }
  };  

  return (
    <div className="quiz-container">
      {!isVerified ? (
        <div className="verification-form">
          <h2>Verify Your Details</h2>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="form-group">
            <label>Mobile:</label>
            <input
              type="text"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              placeholder="Enter your mobile number"
              required
            />
          </div>
          <button className="submit-button" onClick={handleVerifyStudent}>
            Submit
          </button>
        </div>
      ) : (
        <div className="quiz-container">
          <div className="quiz-header">
            <div className="coins">
              <div className="coin-box">
                <span className="coin-icon">💰</span>
                <span className="coin-text">200</span>
              </div>
            </div>
            <h2 className="quiz-title">Fantasy Quiz #{1 + currentQuestion}</h2>
            <button className="close-button">&times;</button>
          </div>

          <div className="upper_section">
            {questions.length > 0 && (
              <>
                <div className="quiz-question">
                  <p>{questions[currentQuestion].question_text}</p>
                </div>

                <div className="quiz-options">
                  {questions[currentQuestion].options.map((option, index) => (
                    <div key={index} className="option-row">
                      <button
                        className={`option-button ${
                          selectedOption === option ? "selected" : ""
                        }`}
                        onClick={() => handleOptionSelect(option)}
                      >
                        <span
                          className={`option-label ${
                            selectedOption === option ? "tick" : ""
                          }`}
                        >
                          {selectedOption === option
                            ? "✔"
                            : String.fromCharCode(65 + index)}
                        </span>
                        <span className="option-text">{option.option_text}</span>
                      </button>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>

          <div className="lower_section">
            <div className="progress-container">
              <div className="progress-bar">
                <div
                  className="progress"
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
              <div className="progress-text">
                {currentQuestion + 1}/{questions.length}
              </div>
            </div>

            <div className="quiz-footer">
              <button
                className="continue-button"
                onClick={handleContinue}
                disabled={!selectedOption}
              >
                {currentQuestion < questions.length - 1 ? "CONTINUE" : "SUBMIT"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TestComponent;
